import React from 'react';
const listeners = new Map();
let attached = false;
const notify = (key) => {
    listeners.get(key)?.forEach(cb => cb());
};
const onStorage = (e) => {
    if (e.storageArea === localStorage && !!e.key && listeners.has(e.key)) {
        notify(e.key);
    }
};
export const useLocalStorage = (key) => {
    if (!listeners.has(key)) {
        listeners.set(key, new Set());
    }
    if (!attached) {
        window.addEventListener('storage', onStorage);
        attached = true;
    }
    const raw = React.useSyncExternalStore((cb) => {
        listeners.get(key).add(cb);
        return () => listeners.get(key).delete(cb);
    }, () => {
        try {
            const x = localStorage.getItem(key);
            return x === null ? null : x;
        }
        catch {
            return null;
        }
    });
    const parsed = React.useMemo(() => {
        try {
            return raw === null ? null : JSON.parse(raw);
        }
        catch {
            return null;
        }
    }, [raw]);
    const set = React.useCallback((x) => {
        try {
            x === null ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(x));
        }
        finally {
            notify(key);
        }
    }, [key]);
    return [parsed, set];
};
export default useLocalStorage;
